import { ResultStatus } from "#/enum";

const TOKEN_STATUS = new Set([2100, 2101, 2102, 2103, 2105, 2109]);

export const getAuthFailureMessage = (error: unknown) => {
	const message = error instanceof Error ? error.message : "";
	if (message === "登录已过期，请重新登录") return message;
	return "登录已过期，请重新登录";
};

export const isApiSuccessStatus = (status: unknown) => Number(status) === ResultStatus.SUCCESS;

export const isAuthFailureStatus = (status: unknown) => {
	const code = Number(status);
	return code === ResultStatus.TIMEOUT || TOKEN_STATUS.has(code);
};

export const shouldNotifyApiError = (silent?: boolean) => !silent;
